import { render, staticRenderFns } from "./serviceConfirmation.vue?vue&type=template&id=4a997963&scoped=true"
import script from "./serviceConfirmation.vue?vue&type=script&lang=js"
export * from "./serviceConfirmation.vue?vue&type=script&lang=js"
import style0 from "./serviceConfirmation.vue?vue&type=style&index=0&id=4a997963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a997963",
  null
  
)

export default component.exports